import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { PersistConfig } from "redux-persist";
import storage from "redux-persist/es/storage";

export type ColorScheme = "light" | "dark" | "system";

interface GeneralState {
	colorScheme: ColorScheme;
}

const initialState: GeneralState = {
	colorScheme: "system",
};

export const generalSlice = createSlice({
	name: "general",
	initialState,
	reducers: {
		setColorScheme: (state, action: PayloadAction<ColorScheme>) => {
			state.colorScheme = action.payload;
		},
	},
});

export const generalPersistConfig: PersistConfig<GeneralState> = {
	key: generalSlice.name,
	storage,
	whitelist: ["colorScheme"],
};

export const { setColorScheme } = generalSlice.actions;
